// extracted by mini-css-extract-plugin
export default {"remainingTime":"FdjTL"};